

function Biofooter() {
  return (
     <div class="bd_landing_sect3  mb-4 bg-white p-3 mt-4 mb-4 rounded-lg shadow-sm">
         <h3 class="bd_l_title">Frequently Asked Questions</h3>

        <details class="faq_panel">
          <summary>Is there any fee for creating a biodata?</summary>
          <p class="selectionShareable">Answer: No, this service is completely free.</p>
        </details>

        <details class="faq_panel">
          <summary>What is a biodata?</summary>
          <p class="selectionShareable">Answer: A biodata is a type of document that includes an individual's personal, family, and professional information. It is usually used for job applications or marriage proposals.</p>
        </details>

        <details class="faq_panel">
          <summary>What is a marriage biodata maker?</summary>
          <p class="selectionShareable">Answer: It is a free online tool that allows you to create and download a marriage biodata.</p>
        </details>

        <details class="faq_panel">
          <summary>How do I start creating a biodata?</summary>
          <p class="selectionShareable">Answer: Visit the website, fill in your personal information, choose a template, and then download the biodata.</p>
        </details>
       
        <details class="faq_panel">
          <summary>What information should be included in the biodata?</summary>
          <p class="selectionShareable">Answer: The biodata should include:
            </p><ul>
              <li>Personal Details (Name, Date of Birth, Address)</li>
              <li>Educational Details (Degrees and details of completed exams)</li>
              <li>Professional Experience</li>
              <li>Family Details</li>
              <li>Contact Information</li>
              <li>Professional and Personal Interests</li>
            </ul>
          <p class="selectionShareable"></p>
        </details>

        <details class="faq_panel">
          <summary>Do I need to create an account to make the biodata?</summary>
          <p class="selectionShareable">Answer: No, you do not need to create an account to create and download the biodata. You can enter your information directly on the website and download it.</p>
        </details>

        <details class="faq_panel">
          <summary>How many types of templates are available?</summary>
          <p class="selectionShareable">Answer: We offer various design templates, allowing you to create a biodata according to your preference.</p>
        </details>

        <details class="faq_panel">
          <summary>Can I create more than one biodata?</summary>
          <p class="selectionShareable">Answer: Yes, you can create and download as many biodatas as you wish.</p>
        </details>

        <details class="faq_panel">
          <summary>How do I download the biodata?</summary>
          <p class="selectionShareable">Answer: After creating the biodata, click on the download button to download the PDF file and image.</p>
        </details>

        <details class="faq_panel">
          <summary>Can the biodata be downloaded in formats other than PDF?</summary>
          <p class="selectionShareable">Answer: Absolutely, you can also download your biodata in image format apart from PDF.</p>
        </details>

        <details class="faq_panel">
          <summary>I accidentally downloaded the biodata, can I create it again?</summary>
          <p class="selectionShareable">Answer: Yes, you can edit your information and create a new biodata with updated details and download it again.</p>
        </details>

        <details class="faq_panel">
          <summary>Is my information secure on your website?</summary>
          <p class="selectionShareable">Answer: Yes, your information is completely secure on our website and is not shared with any third parties.</p>
        </details>

        <details class="faq_panel">
          <summary>Can I create the biodata in any language?</summary>
          <p class="selectionShareable">Answer: Yes, our platform offers options in 8 different languages, including Hindi, Marathi, Gujarati, English, Kannada, Malayalam, Tamil, and Telugu.</p>
        </details>

        <details class="faq_panel">
          <summary>Can I preview the design of the biodata?</summary>
          <p class="selectionShareable">Answer: Yes, you can preview the design before finalizing the biodata to ensure it looks as you want.</p>
        </details>

        <details class="faq_panel">
          <summary>Can the biodata have multiple pages?</summary>
          <p class="selectionShareable">Answer: Yes, if your information is extensive, the biodata can automatically generate multiple pages.</p>
        </details>

        <details class="faq_panel">
          <summary>Can the biodata be accessed from any device?</summary>
          <p class="selectionShareable">Answer: Yes, you can access the biodata from any device, such as a smartphone, tablet, or computer.</p>
        </details>
        
        <details class="faq_panel">
          <summary> Is there a limit to how much information I can include in the biodata?</summary>
          <p class="selectionShareable">Answer: No, you can include as much information as you want in the biodata. The only limitations are related to the design and layout.</p>
        </details>
    </div>
  )
}
export default Biofooter
